module.exports = __webpack_public_path__ + "static/media/400074_02.928b8007.png";